import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutWrap from "../Component/LayoutWrap";
import MainButton from "../Component/UI/MainButton";
import { HiOutlineArrowRight } from "react-icons/hi";
import { dashboardActions } from "../../../_actions";
import { dashboard } from "../../../_reducers/dashboard.reducer";
import { LuCheckCircle2, LuCircle } from 'react-icons/lu';

const quizData = {
  questionTitle: "Question",
  scenario: "Anurag and Mahesh are Sales executives with Arco products. They are a part of Santosh’s team of 6 Sales executives. Santosh’s team has been awarded a very important project by senior leadership on increasing sales in the South region...",
  answerTitle: "Answers",
  options: [
    {
      id: "opt1",
      text: "Anurag should reach out to Santosh immediately and apprise him about his conversation with Mahesh and highlight that Mahesh may not be able to complete his part and deliver on the presentation."
    },
    {
      id: "opt2",
      text: "Anurag should reach out to Santosh immediately and apprise him about his conversation with Mahesh and highlight that Mahesh may not be able to complete his part and deliver on the presentation."
    },
    {
      id: "opt3",
      text: "Anurag should reach out to Santosh immediately and apprise him about his conversation with Mahesh and highlight that Mahesh may not be able to complete his part and deliver on the presentation."
    }
  ]
};

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: "opt1",
    };
  }

  componentDidMount() {
  }

  goToPage = () => {
    this.props.history.push("/insight/dashboard");
  }

  handleSelect = (id) => {
    this.setState({ selectedOption: id });
  };

  render() {

    const { selectedOption } = this.state;

    return (
      <LayoutWrap>
        <div className="p-6 md:p-10 textblack">
          <div className="w-full mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-start h-full">

            {/* Left Column: Question/Scenario */}
            <div className="relative border border-gray-300 rounded-xl p-6 md:p-8 bg-white h-full">
              {/* Label Badge */}
              <div className="absolute -top-3 left-6 bg-white px-4 py-0 text-lg font-bold">
                {quizData.questionTitle}
              </div>

              <div className="mt-4 leading-relaxed textblack text-sm md:text-base whitespace-pre-line">
                {quizData.scenario}
              </div>
            </div>

            {/* Right Column: Answers Selection */}
            <div className="relative border border-gray-300 rounded-xl p-6 md:p-8 bg-white flex flex-col justify-between">
              {/* Label Badge */}
              <div className="absolute -top-3 left-6 bg-white px-4 py-0 text-lg font-medium">
                {quizData.answerTitle}
              </div>

              <div className="space-y-4 mt-4">
                {quizData.options.map((option) => (
                  <div
                    key={option.id}
                    onClick={() => this.handleSelect(option.id)}
                    className={`group flex items-center gap-4 p-5 bg-white rounded-xl border-2 cursor-pointer transition-all duration-200 ${selectedOption === option.id
                      ? 'border-gray-300'
                      : 'border-gray-300 hover:border-gray-300'
                      }`}
                  >
                    <div className="mt-1 flex-shrink-0">
                      {selectedOption === option.id ? (
                        <LuCheckCircle2 className="text-indigo-600" size={36} />
                      ) : (
                        <LuCircle className="text-indigo-600" size={36} />
                      )}
                    </div>
                    <p className="text-sm md:text-base leading-snug textblack">
                      {option.text}
                    </p>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="flex items-center gap-4 mt-8">
                <button className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-purple-800 transition shadow-md">
                  Submit
                </button>
                <button className="px-10 py-2.5 bg-indigo-600 text-white rounded-lg font-bold hover:bg-purple-800 transition shadow-md">
                  Back
                </button>
              </div>
            </div>

          </div>
        </div>
      </LayoutWrap>
    );
  }
}

const mapStateToProps = (state) => ({
  loggingIn: state.authentication?.loggingIn,
  dashboard: state.dashboard,
  user: state.user,
  panel: state.panel,
});

export default connect(mapStateToProps)(Overview);